import { Option } from 'components/_inputs/_types/Option';

import { SubjectDto, Subject, SubjectDetailsDto, SubjectDetails } from './subjects.types';

type ParseSubjectsListForUI = (input: SubjectDto[]) => Subject[];
type ParseSubjectsListForDropdown = (input: SubjectDto[], addSelectAllOption: boolean) => Option[];
type ParseSubjectForUI = (input: SubjectDetailsDto) => SubjectDetails;

const parseSubjectsListForUI: ParseSubjectsListForUI = raw => raw;
const parseSubjectForUI: ParseSubjectForUI = raw => raw;

const parseSubjectsListForDropdown: ParseSubjectsListForDropdown = (raw, addSelectAllOption) => {
  if (!raw) return [];

  const base = raw.map(({ id, name }) => ({ value: id, label: name }));

  if (!addSelectAllOption) return base;
  return [{ value: '', label: 'Wszystkie' }, ...base];
};

const parseSectionDataToDropdown = (data?: { id: string | number; name: string }[]): Option[] => {
  if (!data) return [];

  return [{ value: '', label: 'Wszystkie' }, ...data.map(({ id, name }) => ({ value: id, label: name }))];
};

export { parseSubjectsListForUI, parseSubjectForUI, parseSubjectsListForDropdown, parseSectionDataToDropdown };
